<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂信息修改" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="handleClose" width="577px">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="年份" prop="year">
          <el-select v-model="form.year" placeholder="请选择">
            <el-option label="2027" value="2027"></el-option>
            <el-option label="2026" value="2026"></el-option>
            <el-option label="2025" value="2025"></el-option>
            <el-option label="2024" value="2024"></el-option>
            <el-option label="2023" value="2023"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校名称" prop="college_name">
          <el-select v-model="form.college_code" filterable collapse-tags placeholder="请选择" @change="collegeChange" clearable>
            <el-option v-for="(item, index) in $store.state.collegeList" :key="index" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业名称" prop="major_name">
          <el-select v-model="form.major_code" filterable collapse-tags placeholder="请选择" @change="majorChange" clearable>
            <el-option v-for="(item, index) in majorList" :key="index" :label="item.name" :value="item.code">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学院名称" prop="academy_name">
          <el-select v-model="form.academy_code" filterable collapse-tags placeholder="请选择" @change="academyChange" clearable>
            <el-option v-for="(item, index) in academyList" :key="index" :label="item.name" :value="item.code">
              <span>{{ `${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招生类型" prop="enrol_type">
          <el-select v-model="form.enrol_type" placeholder="请选择">
            <el-option label="全日制" :value="1"></el-option>
            <el-option label="非全日制" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拟招收人数" prop="user_count">
          <el-input v-model="form.user_count" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="联系老师" prop="contact_name">
          <el-input v-model="form.contact_name" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact_mobile">
          <el-input v-model="form.contact_mobile" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="调剂最高分" prop="high_score">
          <el-input v-model="form.high_score" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="调剂最低分" prop="low_score">
          <el-input v-model="form.low_score" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="其他备注" prop="other_remark">
          <el-input type="textarea" v-model="form.other_remark" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="原文地址" prop="source_website">
          <el-input v-model="form.source_website" placeholder="请输入内容"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { editAdjustAdd } from "@/api/adjust";
import { collegeMajorList, academyList } from "@/api/common";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userType: {
      type: Number,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {},
      majorList: [],
      academyList: [],
      rules: {
        year: [{ required: true, message: "请选择年份", trigger: "blur" }],
        college_name: [{ required: true, message: "请选择院校", trigger: "blur" }],
        major_name: [{ required: true, message: "请选择专业", trigger: "blur" }],
        academy_name: [{ required: true, message: "请选择学院", trigger: "blur" }],
        enrol_type: [{ required: true, message: "请选择招生类型", trigger: "blur" }],
        user_count: [{ required: true, message: "请选择拟招生人数", trigger: "blur" }],
        contact_name: [{ required: true, message: "请选择联系人", trigger: "blur" }],
        contact_mobile: [{ required: true, message: "请选择联系方式", trigger: "blur" }],
        high_score: [{ required: true, message: "请选择调剂最高分", trigger: "blur" }],
        low_score: [{ required: true, message: "请选择调剂最低分", trigger: "blur" }],
        other_remark: [{ required: true, message: "请选择其他备注", trigger: "blur" }],
        source_website: [{ required: true, message: "请选择原文地址", trigger: "blur" }],

      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.form = this.content
      this.getAcademy(this.form.college_code, this.form.major_code);
      this.getMajor(
        this.form.college_code
      );
    },
  },
  methods: {
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.form.major_code = ""
      this.form.major_name = ""
      this.form.academy_code = ""
      this.form.academy_name = ""
      this.form.college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e; //筛选出匹配数据
        }
      ).name;
      this.$nextTick(() => {
        this.getMajor(e);
      });
    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || [];
      });
    },
    // 录取专业选择后还要搜索相对应的专业名称
    majorChange(e) {
      this.form.academy_code = ""
      this.form.academy_name = ""
      this.form.major_name = this.majorList.find((item) => {
        return item.code === e; //筛选出匹配数据
      }).name;
      this.$nextTick(() => {
        this.getAcademy(this.form.college_code, e);
      });
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || [];
      });
    },
    // 录取院校选择后还要搜索相对应的院校名称
    academyChange(e) {
      this.form.academy_name = this.academyList.find((item) => {
        return item.code === e; //筛选出匹配数据
      }).name;
    },
    handleClose() {
      this.$emit('close')
    },
    submit() {
      let query = {
        id: this.form.id,
        user_type: this.userType,
        year: this.form.year,
        college_name: this.form.college_name,
        college_code: this.form.college_code,
        major_name: this.form.major_name,
        major_code: this.form.major_code,
        academy_name: this.form.academy_name,
        academy_code: this.form.academy_code,
        enrol_type: this.form.enrol_type,
        user_count: this.form.user_count,
        contact_name: this.form.contact_name,
        contact_mobile: this.form.contact_mobile,
        high_score: this.form.high_score,
        low_score: this.form.low_score,
        other_remark: this.form.other_remark,
        source_website: this.form.source_website,
      }
      editAdjustAdd(query).then((res) => {
        this.handleClose()
      });
    }
  }
}
</script>

<style lang="less" scoped>
.el-select {
  width: 430px;
}
</style>
